export const Sorted = (h) => (props) => (h("svg", { ...props, fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", "aria-hidden": "true" }, h("path", { d: "m12 21-4.5-6.5h9L12 21Z", fill: "currentColor" }), h("path", { d: "M12 3 7.5 9.5h9L12 3Z" })));
//# sourceMappingURL=Sorted.js.map
